import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowRight, Eye } from 'lucide-react';
import Card from './Card';
import Button from './Button';

/**
 * État vide partagé : « Lancer un audit complet ».
 * Mutualise le bloc affiché quand un onglet n'a pas encore de données d'audit
 * (Synthèse, SEO, Performance, Audit visuel).
 *
 * variant:
 *  - 'banner' (défaut) : bandeau ambre compact en haut d'onglet.
 *  - 'centered' : carte centrée pleine page (icône + texte + bouton).
 */
export default function AuditEmptyState({
  title,
  description,
  buttonLabel = 'Lancer un audit complet',
  onAction,
  className = '',
  variant = 'banner',
  icon: Icon = Eye,
}) {
  const navigate = useNavigate();
  const { slug } = useParams();
  const goAudit = onAction || (() => navigate(`/projects/${slug}/audit`));

  if (variant === 'centered') {
    return (
      <Card className={className}>
        <div className="text-center py-12">
          <div className="mx-auto mb-4 w-12 h-12 rounded-xl bg-blue-gray-50 border border-blue-gray-200 flex items-center justify-center">
            <Icon size={22} className="text-blue-gray-500" />
          </div>
          <h2 className="text-lg font-semibold text-blue-gray-900 mb-2">{title}</h2>
          <p className="text-sm text-blue-gray-600 mb-5">{description}</p>
          <Button variant="primary" onClick={goAudit}>
            {buttonLabel} <ArrowRight size={15} className="ml-1" />
          </Button>
        </div>
      </Card>
    );
  }

  return (
    <Card className={`border-amber-200 bg-amber-50 ${className}`}>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h3 className="font-semibold text-amber-900 mb-1">{title}</h3>
          <p className="text-sm text-amber-800">{description}</p>
        </div>
        <Button variant="primary" onClick={goAudit} className="shrink-0">
          {buttonLabel}
        </Button>
      </div>
    </Card>
  );
}
